// import store from '@store';
import roleConfig from '@config/role.config';

//
const hasEditRole = function (role: string) {
    const { roles } = roleConfig;
    const roleItem = role && roles.find(item => item.key === role.toLocaleLowerCase());
    return roleItem && roleItem.canEdit;
};

/**
 * 判断用户身份
 * @param {Array<string>} roles - 要判断的身份列表
 */
const includeRoleWithStore = function (key: string, role: string) {
    const { roleLimited } = roleConfig;
    return roleLimited.includes(key) ? hasEditRole(role) : true;
};

export default {
    hasEditRole,
    includeRoleWithStore
};
